export default __webpack_public_path__ + "static/media/payment-links.c4daba30.png";